import React, { Component } from 'react';
import {Button} from 'reactstrap';
import {staticTitles} from '../../utils/constants';

class ViewToolkit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreviewMode : false
      // public tool url example: https://qaportal.ouroffice.io/public-tool/602edf8f49de4b04fd691f27
    }
  }

  componentDidMount() {
    // console.log(this.props.location.state);
    console.log('tool---', this.props)
    this.setState(this.props.location.state);
  }

  render() {
    // console.log(this.state);
    const {isPreviewMode} = this.state;
    return ( 
      <div>
        <div className="row text-size">
            <h3 className="ml-3">Add {staticTitles.toolkit_sm}</h3>
        </div>
        <div className="row">
          <div className="col-sm-4" >
              <img src="http://support.yumpu.com/en/wp-content/themes/qaengine/img/default-thumbnail.jpg" className="img-thumbnail" alt="Cinque Terre" height="150px" width="150px"/>       
          </div>
          <div className="col-sm-8 pl-5">
            <div className="row">
                <h3>Lorem Ipsum</h3>
            </div>
            <div className="row">
              <span className="vertical-line pr-2"></span>
              <table>
                <tbody>
                  <tr>
                      <td className="pr-2">
                          <div className="text-muted">Owner</div>
                      </td>
                      <td className="pl-2">
                          <div>Mike Hussey</div>
                      </td>
                  </tr>
                  <tr>
                      <td className="pr-2">
                          <div className="text-muted">Location</div>
                      </td>
                      <td className="pl-2">
                          <div>Lafayette, CA</div>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="row mt-3">
            <div className="col-sm-5 pr-0">
                <table>
                  <tbody>
                    <tr>
                        <td><div className="mr-1 ml-1 font-weight-bold">Category: </div></td>
                        <td><div className="text-muted">Talent Sources</div></td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div className="col-sm-7 pl-0 pr-0">
                <table>
                  <tbody>
                    <tr>
                        <td><div className="mr-1 ml-1 font-weight-bold">Privacy: </div></td>
                        <td><div className="text-muted">Public (with my office | View)</div></td>
                    </tr>
                  </tbody>
                </table>
            </div>
        </div>   
          
        <div className="row mt-3">
            <div className="col-sm-5 pr-0">
                <table>
                  <tbody>
                    <tr>
                        <td><div className="mr-1 ml-1 font-weight-bold">Date Added: </div></td>
                        <td><div className="text-muted">NOV 2017</div></td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div className="col-sm-5 pl-0 pr-0">
                <table>
                  <tbody>
                    <tr>
                        <td><div className="mr-1 ml-1 font-weight-bold">Last Updated On: </div></td>
                        <td><div className="text-muted">06/09/2018</div></td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div className="col-sm-2 pl-0 pr-0">
                <table>
                  <tbody>
                    <tr>
                        <td><div className="mr-1 ml-1 font-weight-bold">Views: </div></td>
                        <td><div className="text-muted">0</div></td>
                    </tr>
                  </tbody>
                </table>
            </div>
        </div> 

        <hr size="30"/>
        {/* <div className="row ml-1 mt-3">
            <div className="col">
              <tbody>
                <tr>
                <td><i className="fa fa-envelope fa-2x"></i></td>
                </tr>
              </tbody>
            </div>
            <div className="col">
                <tbody>
                  <tr>
                <td><i className="fa fa-envelope fa-2x"></i></td>
                </tr>
              </tbody>
            </div>
        </div> */}
          <hr size="30"/>

        <div className="row ml-1 mt-3">
            <span><i className="fa fa-paperclip fa-1x ml-1 mr-1"></i></span>
            <a href="#">View Attachment</a>
        </div>

        <div className="row ml-1 mt-2">
            <p className="font-weight-bold">Description</p>
        </div>

        <div className="row ml-1">
            <p className="pr-2 mr-2">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged
            </p>
            <p className="pr-2 mr-2">It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        </div>
        <div className="row ml-1 mt-2">
            <p className="font-weight-bold">Get more details here: <span><a href="#">www.google.com</a></span></p>
        </div>

        {
            isPreviewMode ? 
                <div className="row mt20 mb20">
                    <div className="col-lg-3 col-md-3">
                    <Button onClick={() => {this.props.history.goBack()}} style={{width:'100%'}}>Back to edit</Button>
                    </div>
                    <div className="col-lg-3 col-md-3">
                    <Button style={{width:'100%'}}>Submit</Button>
                    </div>
                </div> : null
        }
      </div>
    )
  }
}
 
export default ViewToolkit;